<div class="category-selector">
  @if (loadingCategories) {
    <div class="loading-indicator">
      <span class="loading-spinner"></span>
      <span>Lade Kategorien...</span>
    </div>
  }

  @if (!loadingCategories && categories.length > 0) {
    <div class="dropdown-wrapper">
      <button
        type="button"
        class="dropdown-trigger"
        [disabled]="loading || loadingCategories"
        role="combobox"
        [attr.aria-expanded]="isOpen"
        [attr.aria-controls]="isOpen ? listboxId : null"
        [attr.aria-activedescendant]="isOpen && activeIndex >= 0 ? optionId(activeIndex) : null"
        aria-label="Platztyp auswählen"
        (click)="toggleDropdown()"
        (keydown)="onTriggerKeydown($event)">
        <app-category-icon [icon]="selectedCategory?.icon" [size]="20"></app-category-icon>
        <span class="trigger-name">{{ selectedCategory?.name || 'Kategorie auswählen' }}</span>
        @if (selectedCategory) {
          <app-category-env-badge
            class="trigger-badge"
            [isIndoor]="selectedCategory.isIndoor || false">
          </app-category-env-badge>
        }
        <span class="trigger-caret" aria-hidden="true">▼</span>
      </button>
      @if (isOpen) {
        <ul
          class="dropdown-panel"
          [id]="listboxId"
          role="listbox"
          aria-label="Platztypen">
          @for (category of categories; track category; let i = $index) {
            <li
              [id]="optionId(i)"
              class="dropdown-option"
              role="option"
              [attr.aria-selected]="category.id === selectedCategoryId"
              [class.selected]="category.id === selectedCategoryId"
              [class.active]="i === activeIndex"
              (click)="selectCategory(category)"
              (mouseenter)="activeIndex = i">
              <app-category-icon [icon]="category.icon" [size]="20"></app-category-icon>
              <span class="option-name">{{ category.name }}</span>
              <app-category-env-badge [isIndoor]="category.isIndoor || false"></app-category-env-badge>
            </li>
          }
        </ul>
      }
    </div>
  }

  @if (!loadingCategories && categories.length === 0) {
    <div class="no-categories">
      Keine Platzkategorien verfügbar
    </div>
  }
</div>
